import React from "react";

export const CountryDetailContext = React.createContext(null);

export const useCountryDetailContext = () => {
  const context = React.useContext(CountryDetailContext);

  if (!context) throw new Error("Country Detail Context not provided!");

  return context;
};
